import { useContext } from "react";
import { Panel } from "@radarly/models/panel";
import { Action } from "../action";
import ChannelContext from "../context";
export function useClosePanel() {
  const { dispatch } = useContext(ChannelContext);
  return (type: Panel["type"]) => {
    dispatch(
      Action.panelClosed({
        type,
      })
    );
  };
}
